const context = {
  activationState: false,
};

export default context;
